window.Mediabank.setApp('dashboard');

//const zxcvbn = require('./zxcvbn');
const countries = require('./countries');
const fotballmedia = require('./fotballmedia');

const $form = $('form');

// google analytics
(function (i, s, o, g, r, a, m) {
    i.GoogleAnalyticsObject = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date(); a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
}(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));

ga('create', 'UA-47137003-1', 'www.mediabank.me');
ga('send', 'pageview');

// Make next-buttons trigger tabs
$('span[role="tab"]').on('click', (e) => {
    const targetTab = $(e.target).data('target');
    $(`a[href="${targetTab}"]`).tab('show');
});

// Initialize form specific js
if ($form.length > 0) {
    $(() => {
        $('[data-toggle="popover"]').popover();
    });

    // const $showPass = $('#show-pass');
    // const $passInput = $('#password');
    // const $passHelp = $($passInput.closest('.form-group').find('.help-block'));
    const $selectCompanyName = $('select#company_name');
    const $selectFmCompanyName = $('select#fm-company');
    const $selectFmClubName = $('select#fm-club');
    const $fmGroup = $('#fm-group');
    const $otherInput = $('#company-type-other');
    const $otherInputHolder = $('#company-type-other-holder');
    const $vatInput = $('#vat');
    let isFotballMedia = false;

    $vatInput.change((e) => {
        const $target = $(e.target);

        if ($target.val().length >= 9 && $target.val().match(/AT|BE|BG|CY|CZ|DK|DE|EE|EL|GR|ES|FI|FR|HR|IT|LV|LT|LU|HU|IE|MT|NL|PL|PT|RO|SI|SK|SE|UK|GB/)) {
            fetch(`http://www.apilayer.net/api/validate?access_key=33c461620e98743f41472aa6d5ce1111&vat_number=${$target.val()}`, {
                method: 'GET',
            })
                .then(res => res.json())
                .then((data) => {
                    if (data.valid === true) {
                        $('#vat-error').empty();

                        $('#country').val(data.country_code);
                        $('#country').trigger('change');
                    } else {
                        $('#vat-error').html('The VAT number could not be validated. Are you sure it\'s correct?');
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    });

    $otherInput.keyup(() => {
        if ($otherInput.val().length > 0) {
            $otherInputHolder.toggleClass('has-content', true);
        } else {
            $otherInputHolder.toggleClass('has-content', false);
        }
    });

    $(() => {
        $('[data-toggle="tooltip"]').tooltip();
    });

/*
    $passInput.on('keyup', (e) => {
        const strength = zxcvbn($(e.target).val());

        if ($passInput.val().length > 0) {
            if (strength.feedback.warning !== '' || strength.feedback.suggestions.length > 0) {
                const str = [];
                strength.feedback.suggestions.map((sug) => {
                    str.push(`<p>${sug}</p>`);
                    return sug;
                });

                if (strength.feedback.warning !== '') {
                    str.push(`<p>${strength.feedback.warning}</p>`);
                }

                $passHelp.html(str.join(' '));
            } else {
                $passHelp.empty();
            }
        } else {
            $passHelp.empty();
        }
    });

    $showPass.on('click', () => {
        if ($passInput.attr('type') === 'text') {
            $($passInput).attr('type', 'password');
            $showPass.find('.btn i').toggleClass('fa-eye-slash', true).toggleClass('fa-eye', false);
        } else {
            $($passInput).attr('type', 'text');
            $showPass.find('.btn i').toggleClass('fa-eye-slash', false).toggleClass('fa-eye', true);
        }
    });
*/

    /*$('#tos').change((e) => {
        $('#submitFormButton').prop('disabled', !$(e.target).prop('checked'));
    });*/

    if ($selectCompanyName.length > 0) {
        // Save company id to input field
        $selectCompanyName.on('select2:select', (e) => {
            $('#cid').val(e.params.data.id);

            // Fotball media
            isFotballMedia = e.params.data.text === 'Fotball Media';
        });

        $('#fm-company').on('select2:select', (e) => {
            const clubs = fotballmedia.clubsFromOrg(e.params.data.id);
            $('#fm-club').empty();
            clubs.map(c => $('#fm-club').append(new Option(c.name, c.id, false, false)).trigger('change'));
        });

        $selectFmCompanyName.select2({
            theme: 'default',
            minimumResultsForSearch: -1,
            data: fotballmedia.organizations.map(el => ({
                id: el.id,
                text: el.name,
            })),
        });

        $selectFmClubName.select2({
            theme: 'default',
            minimumResultsForSearch: -1,
        });
        // companies to be filtered
        const arrExcludedIds = [
            368001,
            3022,
            394001,
        ];

        // Create our select2 input with auto complete
        $selectCompanyName.select2({
            theme: 'default',
            minimumInputLength: 2,
            language: {
                noResults: () => 'Can’t find your company? Please contact support at support@mediabank.com',
            },
            ajax: {
                url: '/ajax/add_user_request.php',
                delay: 250,
                dataType: 'json',
                data(query) {
                    return {
                        method: 'lookup',
                        search: query.term,
                    };
                },
                processResults(data) {
                    if (data.data === null) {
                        return {};
                    }
                    const filtered = data.data.filter(({ id }) => !arrExcludedIds.includes(id)); // filtering companies from the list
                    return {

                        results: $.map(filtered, res => ({
                            text: res.name,
                            id: res.id,
                            logo: res.logo_url,
                        })),
                    };
                },
            },
        }).addClass('form-control');
    }
    // Add regex function to jQuery Validation
    $.validator.addMethod('regx', (value, element, regexpr) => regexpr.test(value));

    // Define our jQuery form validation and add options for bootstrap
    $form.map((i, el) => {
        const $el = $(el);
        $el.validate({
            ignore: [],
            highlight(element) {
                const $elem = $(element);
                const $fg = $elem.closest('.form-group');
                $fg.addClass('has-error');
            },
            unhighlight(element) {
                const $elem = $(element);
                const $fg = $elem.closest('.form-group');
                $fg.removeClass('has-error');
            },
            rules: {
                hiddenRecaptcha: {
                    required() {
                        if (grecaptcha.getResponse() === '') {
                            return true;
                        }

                        return false;
                    },
                },
                company_type: {
                    required() {
                        // If other has content, radio is not required
                        return $('input[name="company_type_other"]').val().length <= 0;
                    },
                },
                company_type_other: {
                    // If radio is checked, other is not required
                    required() {
                        return !$('input[name="company_type"]').is(':checked');
                    },
                },
            },
            errorPlacement(error, element) {
                return false;
            },
            showErrors(errorMap, errorList) {
                this.defaultShowErrors();
                $el.find('label.has-error').removeClass('hidden');
            },
            success() {
                $el.find('label.has-error').addClass('hidden');
            },
        });

        // If the clicked tab is disabled, handle it as a disabled tab!
        const $currentTab = $(`a[href="#${$el.attr('id').replace('form', 'tab')}"]`);
        $currentTab.on('show.bs.tab', (e) => {
            if ($($(e.target).parent('li')).hasClass('disabled')) {
                e.preventDefault();
            }
        });

        // If next tab is activated, validate current form
        $currentTab.parent('li').next('li').children('a')
            .on('show.bs.tab', (e) => {
                if (isFotballMedia) {
                    location.assign('https://admin.mediabank.me/admin/fotballmedia/');
                }
                const $activeTab = $(e.target).parent('li').siblings('li.active');
                const activeForm = $activeTab.children('a')
                    .attr('href')
                    .replace('tab', 'form');

                if (!$el.valid() || !$(activeForm).valid()) {
                    e.preventDefault();
                    $activeTab.removeClass('has-error').addClass('has-error')
                        .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', () => {
                            $activeTab.removeClass('has-error');
                        },
                    );
                }
            },
        );

        $el.find('select').on('change', () => {
            if ($el.valid()) {
                $el.find('label.has-error').addClass('hidden');
            } else {
                $el.find('label.has-error').removeClass('hidden');
            }
        });
    });

    $('#country').select2({
        theme: 'default',
        data: countries.countries.map(country => ({
            id: country.code,
            text: country.name,
        })),
    }).addClass('form-control');

    $('#country_code').select2({
        theme: 'default',
        data: countries.countries.map(country => ({
            id: country.dial_code,
            text: `${country.name} (+${country.dial_code})`,
        })),
    });

    $('#register_user').click((e) => {
        if ($($form[$form.length - 1]).valid()) {
            const $e = $(e.target);
            $e.addClass('disabled');
            $e.html('<i class="fa fa-spinner fa-spin"></i>');

            const body = $form.serialize();

            fetch('/ajax/add_user_request.php', {
                method: 'post',
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                body,
            })
                .then(req => req.json())
                .then((data) => {
                    $('a[href="#tab-verification"]').tab('show');

                    if (data.status === 'OK') {
                        $('li[role="presentation"]:not(:last-child)').addClass('disabled');
                        $('#verification-email-used').hide();
                        $('#verification-error').hide();
                    } else if (data.error === 'E_Error') {
                        $('#verification-success').hide();
                        $('#verification-email-used').show();
                        $e.removeClass('disabled');
                        $e.html('Register');
                    } else {
                        $('#verification-success').hide();
                        $('#verification-error').show();
                        $e.removeClass('disabled');
                        $e.html('Register');
                    }
                })
                .catch((err) => {
                    $('#verification-success').hide();
                    $('#verification-error').show();
                });
        }
    });
}



// WEBPACK FOOTER //
// ./apps/registration/scripts/main.js